import React, { useState, useRef, useEffect } from "react";
import logo from "../Assets/logogeniac.png";
import {
  IoSettingsOutline,
  IoHelpCircleOutline,
  IoSearchOutline,
} from "react-icons/io5";
import { useTranslation } from 'react-i18next';

import { NotificationBell } from "../Notifications";
import SettingsMenu from "./SettingsMenu";
import HelpMenu from "./HelpMenu";
import UserMenu from "./UserMenu";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { useWhiteLabel } from "../../context/WhiteLabelContext";

const Header = () => {
  const { t } = useTranslation('dashboard');
  const { config: wl } = useWhiteLabel();
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [showHelpMenu, setShowHelpMenu] = useState(false);

  const settingsRef = useRef(null);
  const helpRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        settingsRef.current &&
        !(settingsRef.current as any).contains(event.target) &&
        helpRef.current &&
        !(helpRef.current as any).contains(event.target)
      ) {
        setShowSettingsMenu(false);
        setShowHelpMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="relative flex items-center justify-between bg-gray-100 px-4 py-2 shadow-sm">
      {/* Gauche */}
      <div className="flex items-center space-x-3">
        <img
          src={wl?.logo_url || logo}
          alt={wl?.app_name || 'GenIaC'}
          className="h-10 w-auto object-contain"
          onError={(e) => { (e.target as HTMLImageElement).src = logo; }}
        />
        {wl?.app_name && wl.app_name !== 'GenIaC' && (
          <span className="font-semibold text-gray-800 text-lg hidden sm:block">{wl.app_name}</span>
        )}
      </div>

      {/* Centre - Recherche */}
      <div className="flex-1 mx-6 max-w-md">
        <div className="flex items-center border border-gray-300 rounded-md px-2 py-1 bg-white">
          <IoSearchOutline className="text-gray-400 mr-2" />
          <input
            type="text"
            placeholder={t('header.searchPlaceholder')}
            className="w-full outline-none text-sm bg-transparent"
          />
        </div>
      </div>

      {/* Droite */}
      <div className="flex items-center space-x-4 text-gray-700 relative">
        {/* Notifications - Nouveau système amélioré avec badge */}
        <NotificationBell />

        {/* Paramètres */}
        <div ref={settingsRef}>
          <IoSettingsOutline
            className="text-xl hover:text-blue-600 cursor-pointer"
            onClick={() => setShowSettingsMenu((prev) => !prev)}
          />
          <SettingsMenu
            isOpen={showSettingsMenu}
            onClose={() => setShowSettingsMenu(false)}
          />
        </div>

        {/* Sélecteur de langue */}
        <LanguageSelector />

        {/* Aide */}
        <div ref={helpRef}>
          <IoHelpCircleOutline
            className="text-xl hover:text-blue-600 cursor-pointer"
            onClick={() => {
              setShowHelpMenu((prev) => !prev);
              setShowSettingsMenu(false);
            }}
          />
          <HelpMenu
            isOpen={showHelpMenu}
            onClose={() => setShowHelpMenu(false)}
          />
        </div>

        {/* Menu utilisateur */}
        <UserMenu />
      </div>
    </header>
  );
};

export default Header;
